import classNames from 'classnames';
import React, { useState } from 'react';

const InfoBox = ({ hoverMessage, spanClassName, iconClassName }) => {
	const [isHovering, setIsHovering] = useState(false);
	const cls = classNames('glass_product_info_box', spanClassName);
	const icoCls = classNames('glass_product_info_box_icon', iconClassName);

	return (
		<span
			className={cls}
			onMouseEnter={() => setIsHovering(true)}
			onMouseLeave={() => setIsHovering(false)}
		>
			<span className={icoCls}>ⓘ</span>
			{isHovering && (
				<div className="glass_product_info_box_message">
					{hoverMessage.split('\n').map((line, index) => (
						<React.Fragment key={index}>
							{line}
							<br />
						</React.Fragment>
					))}
				</div>
			)}
		</span>
	);
};

export default InfoBox;
